import React, { useEffect, useState } from 'react'
import Dialog from '../../common/Dialog'
import $t from '../../../i18n'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'antd'
import Actions from '../../../actions'
import MaterialInput from '../../common/MaterialInput'
import { getOwnerMember } from 'utils/memberUtils'
import { isEmpty } from 'lodash'

import './ShareQuoteDialog.css'

const getValidationErrors = ({ email }) => {
  const result = {}

  // 11 digits - 10 phone + 1 country code
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!email || !email?.toLowerCase()?.match(EMAIL_REGEX)) {
    result.email = $t('errors.validation.invalidEmail')
  }

  return (!isEmpty(result) && result) || null
}

const ShareQuoteDialog = () => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [shouldValidate, setShouldValidate] = useState(false)

  const isShareQuoteDialogVisible = useSelector(
    state => state.app?.isShareQuoteDialogVisible
  )

  const isShareQuoteLoading = useSelector(
    state => state.plan?.isShareQuoteLoading
  )

  const members = useSelector(state => state.member.members)
  const ownerMember = getOwnerMember(members)

  const errors = shouldValidate && getValidationErrors({ email })

  useEffect(() => {
    if (ownerMember) {
      setEmail(ownerMember?.email)
    }
  }, [ownerMember])

  const closeDialog = () => {
    dispatch(Actions.createAction(Actions.SHARE_QUOTE_DIALOG_CLOSED))
  }

  const updateOwnerFields = () => {
    // update email for owner member
    dispatch(
      Actions.createAction(Actions.MEMBER_INFO_CHANGED, {
        key: 'email',
        value: email,
        id: ownerMember?.id
      })
    )
  }

  const onSend = () => {
    if (getValidationErrors({ email })) {
      setShouldValidate(true)
      return
    }
    setShouldValidate(false)
    updateOwnerFields()
    const linkToApplications = window.location.href

    dispatch(
      Actions.createAction(Actions.SHARE_QUOTE_REQUESTED, {
        linkToApplications,
        email
      })
    )
  }
  return (
    <Dialog
      title={$t('dialogs.shareQuote.title')}
      isVisible={isShareQuoteDialogVisible}
      footerActions={[]}
      onCancel={closeDialog}
      className='share-quote-dialog'
    >
      <div className='share-quote-dialog-content'>
        <div className='share-quote-subtitle subtitle'>
          {$t('dialogs.shareQuote.description')}
        </div>
        <div className='fields-container'>
          <div className='fields'>
            <MaterialInput
              label={$t('fields.email')}
              value={email}
              errorText={errors?.email}
              onChange={e => setEmail(e?.target?.value)}
            />
          </div>

          <Button
            className='dialog-action'
            type='primary'
            onClick={onSend}
            loading={isShareQuoteLoading}
          >
            {$t('common.submit')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default ShareQuoteDialog
